import './assets/css/App.css';
import ReactDOM from "react-dom/client";
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import MasterLayout from './layouts/master';
import DoctorLayout from './layouts/doctor'
import Counselor from 'layouts/counselors/Index';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js'
import {
  ChakraProvider,
} from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import { Provider, useDispatch } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import rootReducers from './redux/reducers/Index.reducer'
import Protected from 'views/auth/Protected';
import AddAppoinment from 'views/admin/addAppointment'
import BarCode from 'views/barcode';
import VoucherBill from 'views/voucherBill/Index';
import Billing from 'views/billing/Index'
import MedicineBill from 'views/doctor/medicineBill/MedicineBill';
import Therapist from 'layouts/therapist/Index';
import { useEffect } from 'react';
import { loginSuccess } from './redux/actions/Admin.action';
import SelfRegister from 'views/SelfRegister';
// Chakra imports
import ChatProvider from './contexts/chatProvider';

const store = createStore(rootReducers, applyMiddleware(thunk));
function AuthInitializer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === '/user-register') {
      return; // Don't check authentication for this route
    }

    const lastLoginTime = localStorage.getItem('lastLoginTime');
    const now = Date.now();

    // Check if 12 hours have passed (12 * 60 * 60 * 1000 ms)
    if (lastLoginTime && now - parseInt(lastLoginTime, 10) > 12 * 60 * 60 * 1000) {
      localStorage.clear();
      navigate('/auth/sign-in');
    }

    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    if (isAuthenticated) {
      dispatch(loginSuccess());
    } else {
      navigate('/auth/sign-in');
    }
  }, [dispatch]);

  return null;
}


export default function Main() {

  const root = ReactDOM.createRoot(document.getElementById("root"));

  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  return (
    <Provider store={store}>
      <ChakraProvider theme={currentTheme}>
        {/* <ChatProvider> */}
          <AuthInitializer />
          <Routes>
          <Route path="auth/*" element={<AuthLayout />} />
          <Route path="admin/*" element={<Protected><AdminLayout theme={currentTheme} setTheme={setCurrentTheme} /></Protected>} />
          <Route path="master/*" element={<Protected> <MasterLayout theme={currentTheme} setTheme={setCurrentTheme} /></Protected>} />
          <Route path="doctor/*" element={<Protected> <DoctorLayout theme={currentTheme} setTheme={setCurrentTheme} /></Protected>} />
          <Route path="counselor/*" element={<Protected> <Counselor theme={currentTheme} setTheme={setCurrentTheme} /></Protected>} />
          <Route path="therapist/*" element={<Protected> <Therapist theme={currentTheme} setTheme={setCurrentTheme} /></Protected>} />
          <Route path="barcode/:slug" element={<BarCode />} />
          <Route path="voucher/:id" element={<VoucherBill />} />
          <Route path="billing/:id" element={<Billing />} />
          <Route path="medicine/:id" element={<MedicineBill />} />
          <Route path="/" element={<Protected> <Navigate to="/admin" replace /></Protected>} />
          <Route path='/user-register' element={<SelfRegister />} />
        </Routes>
        <ToastContainer />
        {/* </ChatProvider> */}
      </ChakraProvider>
    </Provider>
  );
}
